import { RootState } from 'types/store';
import { useAppSelector } from './redux';
import { Totals, getTotals } from 'containers/CartContainer/CartContainer.utils';
import { useTranslation } from 'react-i18next';
import { TFunction } from 'i18next';

type DisabledMessages = {
    paymentMethod: PaymentMethodName;
    disabledMessage: string | null;
}[];

export const useDisabledMessage = (): DisabledMessages => {
    const { t } = useTranslation();
    const rules = useAppSelector((state: RootState) => state.rule.data);
    const cart = useAppSelector((state: RootState) => state.cart.data);
    const totals = cart != null ? getTotals(cart) : ({} as Totals);
    const paymentMethodName: PaymentMethodName[] = [
        'Alignet',
        'ChekCard',
        'Cybersource',
        'InStore',
        'Niubiz',
        'Niubiz3DS',
        'RipleyCard',
        'RipleyChek',
        'RipleyChekCard',
        'RipleyChekCardFakeButton',
        'RipleyGiftCard',
        'RipleyNiubiz',
        'WebpayCredito',
        'WebpayDebito',
        'Orbis',
    ];
    const rangeDisabledMessages = paymentMethodName.map((pm) => {
        const rangeDisabledMessage = getRangeDisabledMessage(
            pm,
            rules['paymentAmountRange'],
            totals,
            t,
        );
        return { paymentMethod: pm, disabledMessage: rangeDisabledMessage };
    });
    return rangeDisabledMessages;
};

export const getRangeDisabledMessage = (
    paymentMethodName: PaymentMethodName,
    paymentAmountRanges: PaymentAmountRange[],
    totals: Totals,
    t: TFunction<'translation', undefined>,
) => {
    // Min and Max value of a price
    const max =
        paymentAmountRanges?.find((range) => range.paymentMethod == paymentMethodName)?.max ?? 0;
    const min =
        paymentAmountRanges?.find((range) => range.paymentMethod == paymentMethodName)?.min ?? 0;

    // The total at this stage will be always normal (no payment methods selected)
    const totalAmount = totals['normal'];

    if (totalAmount) {
        // validation
        if (paymentMethodName === 'Orbis' && totalAmount > max) {
            return t('maxAmountExceededOrbis');
        }

        if (max === 0) {
            if (totalAmount < min) {
                return t('minAmountExceeded');
            }
            return null;
        }
        if (totalAmount < min) {
            return t('minAmountExceeded');
        }
        if (totalAmount > max) {
            return t('maxAmountExceeded');
        }
    }
    return null;
};
